import type { EquipmentStatusHistoryTableViewModel } from 'ab-viewModels/equipmentStatusHistoryTable.viewModel';

const CSV_HEADER_KEYS = [
	'Status',
	'Status Valid',
	'Unavailability Reason',
	'Failure Details',
];

export const toCSVData = (viewModels: EquipmentStatusHistoryTableViewModel[]): string[][] => {
	const header: string[] = [...CSV_HEADER_KEYS];

	const rows: string[][] = viewModels.map((_entry: EquipmentStatusHistoryTableViewModel) => {
		const _row: string[] = [
			_entry?.status?.name ?? 'Available',
			_entry?.statusValidTo ? `from ${_entry?.statusValidFrom} to ${_entry?.statusValidTo}` : `from ${_entry?.statusValidFrom}`,
			_entry?.unavailabilityReason ?? 'None',
			_entry?.failureDetails ?? 'None',
		];
		return _row;
	});

	return [header, ...rows];
};
